module.exports = __webpack_public_path__ + "img/@tmp_facility_list_01.7ec8fbfa.jpg";